import { render, staticRenderFns } from "./videoReviewList.vue?vue&type=template&id=e9609a32&scoped=true&"
import script from "./videoReviewList.vue?vue&type=script&lang=js&"
export * from "./videoReviewList.vue?vue&type=script&lang=js&"
import style0 from "./videoReviewList.vue?vue&type=style&index=0&id=e9609a32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9609a32",
  null
  
)

export default component.exports